import * as Sentry from '@sentry/gatsby'

const ANON_ID_KEY = 'sentry-anon-id'

const generateId = () =>
  typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`

// Random id kept in localStorage, no PII. Storage can throw (Safari privacy),
// in which case the user stays unidentified.
export const getAnonymousId = (): string | null => {
  try {
    const stored = window.localStorage.getItem(ANON_ID_KEY)

    if (stored) return stored

    const id = `anon-${generateId()}`

    window.localStorage.setItem(ANON_ID_KEY, id)

    return id
  } catch {
    return null
  }
}

export const identifySentryUser = (sub?: string | null) => {
  if (sub) {
    Sentry.setUser({ id: sub })

    return
  }

  const anonId = getAnonymousId()

  Sentry.setUser(anonId ? { id: anonId } : null)
}
